<template>
    <div>
<b-modal id="addRequestModal" size="xl" class="modal has-overflow">
  <div class="e-loader-back" v-if="loading">
            <div class="e-loader-content">
              <div class="ball-clip-rotate-multiple">
                <div></div>
                <div></div>
              </div>
              <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
            </div>
          </div>
        <template v-slot:modal-header>
          <div class="w-100">
            <h4 class="e-mtavr-17 e-bold modal-title">ახალი მოთხოვნა</h4>
          </div>
        </template>
        <form>
          <div class="row no-gutters row-bordered">
            <!-- Login -->
            <div class="col-md-6">
              <h5
                class="text-center py-4 px-4 px-sm-5 m-0 e-mtavr-14 e-bold text-muted"
              >პირადი მონაცემები</h5>
              <hr class="border-light m-0" />

              <div class="px-4 px-sm-5 pt-4 pb-5 pb-sm-5">
                <!-- personal info form -->
                <b-form-group label="იურიდიული სტატუსი" class="e-nusx-8 text-muted">
                <b-radio-group class="e-nusx-8 text-muted" v-model="newReq.request.juridicalstatusid" :options="[{text: 'ფიზიკური პირი', value: 1}, {text: 'იურიდიული პირი', value: 2}]" />
                </b-form-group>
                <b-form-group label="სახელი" class="e-nusx-8 e-bold text-muted" v-if="newReq.request.juridicalstatusid === 1">
                  <b-input v-model="newReq.request.firstName" class="e-eng-font" />
                </b-form-group>
                <b-form-group label="დასახელება" class="e-nusx-8 e-bold text-muted" v-if="newReq.request.juridicalstatusid === 2">
                  <b-input v-model="newReq.request.firstName" class="e-eng-font" />
                </b-form-group>
                <b-form-group label="გვარი" class="e-nusx-8 e-bold text-muted" v-if="newReq.request.juridicalstatusid === 1">
                  <b-input v-model="newReq.request.lastName" class="e-eng-font" />
                </b-form-group>
                <b-form-group label="ქვეყანა" class="e-nusx-8 e-bold text-muted" v-if="newReq.request.juridicalstatusid === 1">
                  <b-input v-model="newReq.request.countryISO" autocomplete="off" id="countryinput" class="e-eng-font" @input="filterCountries()" @focus="filterCountries(), showPop = true"/>
                  <b-popover id="primaryPopover-container" container="primaryPopover-container" target="countryinput" custom-class="e-popover-danger" placement="bottom" triggers="manual" :show.sync="showPop">
                     <ul class="e-liststyle-none e-eng-font e-listinpopover">
                      <li v-for="cntry in filteredCountriesList" :key="cntry.$index" @click="setCountry(cntry)" class="g-cursor-pointer">{{cntry.countryName}}</li>
                    </ul>
                  </b-popover>
                </b-form-group>
                <b-form-group label="რეზიდენტობა" class="e-nusx-8 e-bold text-muted" v-if="newReq.request.juridicalstatusid === 2">
                  <b-input v-model="newReq.request.countryISO" autocomplete="off" id="countryinput" class="e-eng-font" @input="filterCountries()" @focus="filterCountries(), showPop = true"/>
                  <b-popover id="primaryPopover-container" container="primaryPopover-container" target="countryinput" custom-class="e-popover-danger" placement="bottom" triggers="manual" :show.sync="showPop">
                     <ul class="e-liststyle-none e-eng-font e-listinpopover">
                      <li v-for="cntry in filteredCountriesList" :key="cntry.$index" @click="setCountry(cntry)" class="g-cursor-pointer">{{cntry.countryName}}</li>
                    </ul>
                  </b-popover>
                </b-form-group>
                <b-form-group label="დაბადების თარიღი" class="e-nusx-8 e-bold text-muted" v-if="newReq.request.juridicalstatusid === 1">
                  <datepicker
                    v-model="newReq.request.brthDate"
                    :bootstrapStyling="true"
                    :language="locale"
                    :monday-first="true"
                    placeholder="თარიღი არ არის არჩეული"
                    :calendar-button="true"
                    calendar-button-icon="far fa-calendar-alt"
                  />
                </b-form-group>
                 <b-form-group label="რეგისტრაციის თარიღი" class="e-nusx-8 e-bold text-muted" v-if="newReq.request.juridicalstatusid === 2">
                  <datepicker
                    v-model="newReq.request.brthDate"
                    :bootstrapStyling="true"
                    :language="locale"
                    :monday-first="true"
                    placeholder="თარიღი არ არის არჩეული"
                    :calendar-button="true"
                    calendar-button-icon="far fa-calendar-alt"
                  />
                </b-form-group>
                 <b-form-group label="პირადი ნომერი" class="e-nusx-8 e-bold text-muted" v-if="newReq.request.juridicalstatusid === 1">
                  <b-input v-model="newReq.request.personalN" class="e-eng-font"/>
                </b-form-group>
                <b-form-group label="რეგისტრაციის ნომერი" class="e-nusx-8 e-bold text-muted" v-if="newReq.request.juridicalstatusid === 2" >
                  <b-input v-model="newReq.request.personalN" class="e-eng-font"/>
                </b-form-group>
                <!-- / personal info form -->
              </div>
            </div>
            <!-- / Login -->

            <!-- Register -->
            <div class="col-md-6 e-border-left">
              <h5
                class="text-center py-4 px-4 px-sm-5 m-0 e-mtavr-14 e-bold text-muted"
              >ძებნის პარამეტრები</h5>
              <hr class="border-light m-0" />

              <div class="px-4 px-sm-5 pt-4 pb-5 pb-sm-5">
                <!-- Register form -->
                <b-form-group label="დამთხვევის %" class="e-nusx-8 e-bold text-muted">
                  <vue-slider
                    ref="Coinsidence_slider"
                    v-model="newReq.request.matchPercent"
                    :tooltip="'always'"
                  ></vue-slider>
                </b-form-group>
                <b-form-group label="თქვენს მიერ შეძენილი გადამოწმების პაკეტი" class="e-nusx-8 e-bold text-muted">
                  <b-form-radio
                  disabled
                    v-for="spack in scanningPackets"
                    :key="spack.$index"
                    v-model="newReq.request.scanningPacketId"
                    :value="spack.id"
                    class="m-0 font-weight-normal"
                  >{{spack.name}}</b-form-radio>
                </b-form-group>
                <b-form-group
                  label="სანქციების გადასამოწმებელი ბაზები"
                  class="e-nusx-8 e-bold text-muted"
                >
                <b-form-checkbox
                      v-model="selectAll"
                      class="mt-4"
                      type="checkbox"
                    >
                      <span class="e-nusx-8 e-bold">ყველას მონიშვნა</span>
                    </b-form-checkbox>
                <div v-for="scdb in scannigPacketDatabases" :key="scdb.$index">
                <b-form-checkbox v-model="newReq.request.scannigPacketDatabases" :value="scdb.id" class="mt-4" v-if="scdb.scanningPacketID === newReq.request.scanningPacketId">
                    <span class="e-text-eng-1 e-bold" >{{scdb.name}}</span>
                    <p>
                      <small class="e-text-eng-1">
                        {{scdb.description}}
                      </small>
                    </p>
                  </b-form-checkbox>
                  </div>
                </b-form-group>
                <!-- / Register form -->
              </div>
            </div>
            <!-- / Register -->
          </div>
        </form>
        <template v-slot:modal-footer>
          <div class="w-100">
            <b-button
              size="sm"
              variant="btn btn-primary"
              @click="save()"
              class="float-right e-mtavr-17"
            >გადამოწმება</b-button>
            <b-button
              size="sm"
              variant="btn btn-secondary"
              @click="close('addRequestModal')"
              class="float-right e-mtavr-17 mr-2"
            >გაუქმება</b-button>
          </div>
        </template>
      </b-modal>
    </div>
</template>

<script>
import 'loaders.css/loaders.css'
import 'spinkit/spinkit.css'
import BaseService from '@/backend/vue-axios/axios.js'
import Datepicker from 'vuejs-datepicker'
import { ge } from 'vuejs-datepicker/dist/locale'
import vueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/ething-material.css'
import moment from 'moment'
export default {
  components: {
    vueSlider,
    Datepicker
  },
  // metaInfo: {
  //   title: ' - ახალი მოთხოვნის დატამება'
  // },
  data () {
    return {
      loading: false,
      showPop: false,
      fullCountryList: [],
      filteredCountriesList: [],
      scanningPackets: this.$store.getters.GetscanningPackets,
      scannigPacketDatabases: this.$store.getters.GetscannigPacketDatabases,
      purchasedScanningPackage: this.$store.getters.GetPurchasedScanningPacket,
      // currentUser: this.$store.getters.GetCurrentUser,
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      newReq: {
        request: {
          id: 0,
          recDate: '',
          matchPercent: 78,
          firstName: '',
          lastName: '',
          country: '',
          countryISO: '',
          personalN: '',
          address: '',
          brthDate: 'თარიღი არ არის არჩეული',
          transactionN: '',
          scanningTypeId: 0,
          scanningType: '',
          scanningPacketId: 1,
          scanningPacketName: '',
          scanningDatabases: [],
          decisionResultId: 0,
          decisionResult: '',
          decisionUserId: 0,
          decisionUser: '',
          addingReasonId: 0,
          addingReason: '',
          organisationId: 0,
          userId: 0,
          userName: '',
          userFirstName: '',
          userLastName: '',
          statusChangeDate: null,
          statusChangeUserId: 0,
          statusChangeUserName: '',
          status: 0,
          statusText: '',
          matchedBlackListId: 0,
          matchedWhiteListId: 0,
          dboforigination: '',
          commentText: '',
          commentUserId: 0,
          commentUserName: '',
          matchCount: 0,
          deleteStatus: false,
          organisationUserId: 0,
          juridicalstatusid: 1,
          checkInAcuris: true,
          comments: [],
          scannigPacketDatabases: []
        }
      },
      locale: ge
    }
  },
  created () {
    this.scannigPacketDatabases = this.scannigPacketDatabases.filter(
      (sdb) => sdb.scanningPacketID === this.purchasedScanningPackage.scanningPacketId
      // (sdb) => sdb.scanningPacketID === this.purchasedScanningPackage
    )
    this.newReq.request.scanningPacketId = this.purchasedScanningPackage.scanningPacketId
  },
  computed: {
    currentUser () {
      return this.$store.getters.GetCurrentUser
    },
    selectAll: {
      get: function () {
        return this.scannigPacketDatabases
          ? this.newReq.request.scannigPacketDatabases.length ===
              this.scannigPacketDatabases.length
          : false
      },
      set: function (value) {
        var selected = []
        if (value) {
          this.scannigPacketDatabases.forEach(function (SDB) {
            selected.push(SDB.id)
          })
        }
        this.newReq.request.scannigPacketDatabases = selected
      }
    }
  },
  methods: {
    save () {
      // this.loading = true
      this.newReq.request.recDate = moment(Date.now()).format()
      this.newReq.request.organisationId = this.currentUser.organizationID
      this.newReq.request.userId = this.currentUser.id
      this.newReq.request.userName = this.currentUser.userName
      this.newReq.request.userFirstName = this.currentUser.firstName
      this.newReq.request.userLastName = this.currentUser.lastName
      this.newReq.request.userLastName = this.currentUser.lastName
      if (this.newReq.request.brthDate === 'თარიღი არ არის არჩეული') {
        this.newReq.request.brthDate = null
      }
      // console.log(this.newReq)
      BaseService.AddRequestWithDetails(this.header, this.newReq.request)
        .then(res => {
          if (res.data.success) {
            this.loading = false
            this.selectAll = false
            this.newReq.request.firstName = ''
            this.newReq.request.lastName = ''
            this.newReq.request.brthDate = ''
            this.newReq.request.countryISO = ''
            this.newReq.request.personalN = ''
            this.newReq.components = []
            // this.newReq.request.scannigPacketDatabases = []
            this.$bvModal.hide('addRequestModal')
            this.$emit('RequestAdded')
            this.$store.commit('DCRSsearches')
          }
        })
      // console.log(this.newReq)
    },
    close (id) {
      this.$bvModal.hide(id)
    },
    filterCountries () {
      // debugger // eslint-disable-line
      if (this.filteredCountriesList.length === 0) {
        this.filteredCountriesList = this.fullCountryList
      }
      this.filteredCountriesList = this.fullCountryList.filter(cntry => {
        this.showPop = true
        return cntry.twoCharCountryCode.toLowerCase().startsWith(this.newReq.request.countryISO.toLowerCase())
      })
    },
    setCountry (data) {
      this.newReq.request.countryISO = data.twoCharCountryCode
      this.newReq.request.country = data.countryName
      this.showPop = false
    }
  },
  mounted () {
    this.fullCountryList = this.$store.getters.GetCountriesList
  }
}
</script>
